import { render } from "./SideBarItem.vue?vue&type=template&id=5fc833ff"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"

import "./SideBarItem.vue?vue&type=style&index=0&id=5fc833ff&lang=scss"
script.render = render

export default script